import { Component, Input, OnInit,  ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { AlertComponent } from '../../alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { FinanceServicesService } from 'src/app/services/finance-services.service';
import { environment } from 'src/environments/environment';
import { AddCompanyDetailsService } from 'src/app/services/add-company-details.service';
import { LoaderService } from 'src/app/services/loader.service';
@Component({ 
  selector: 'app-add-finance-details',
  templateUrl: './add-finance-details.component.html',
  styleUrls: ['./add-finance-details.component.css']
})
export class AddFinanceDetailsComponent implements OnInit {

  public environmentSettings: any;

  nameModel: any;
  Amount: any;
  activeclassflag: boolean;
  // @Input() totalPaid: any;
  @Input() paidupEquity: any;
  @Input() paidupPreference: any;
  @ViewChild(DataTableDirective)
  surplusOthers: any;
  debitBalance: any;
  surplus: any;
  reneralReserve: any;
  subscribedEquity: any;
  issuedEquity: any;
  authorizedEquity: any;
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  companyMasterForm: FormGroup;
  financialDataForm: FormGroup;
  companies: any[];
  classesOfCompany: any[];
  typesOfCompany: any[];
  registrationIDTypes: any[];
  typesOfIndustry: any[];
  financialYears: any[];
  companyId: string;
  CompanyList: any;
  financialDataList: any;
  showSelected: boolean;
  equityListing: any;
  equityListingSMESegment: any;
  onlyDebtListing: any;
  debtListing: any;
  globalIncorporationYear: any;
  financialYearFromModel: any;
  financialYearToModel: any;
  dateOfIncorporationModel: any;
  error: any = { isError: false, errorMessage: '' };
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  companyAutoCompleteList: any;
  companyNameModel: any;
  peersList: any;
  selectedPeers: any;
  industryCode: any;
  housingCode: any;
  invalidPeers: any;
  errors: any = { isError: false, errorMessage: '' };
  IssuedEquityError: any = { isError: false, errorMessage: '' };
  SubscribedShareCapital: any = { isError: false, errorMessage: '' };
  PaidupEquityShareCapital: any = { isError: false, errorMessage: '' };
  IssuedPreferenceShareCapital: any = { isError: false, errorMessage: '' };
  SubscribedPreferenceShareCapital: any = { isError: false, errorMessage: '' };
  PaidupPreferenceShareCapital: any = { isError: false, errorMessage: '' };
  chosenPeers: any;
  number = 0.5;
  totals: number;
  value2: number;
  paidup: any;
  totalPaidTab1: any;
  totalFreeReserveAmount: any;
  OtherthanfreeReservesAmount: any;
  TotalReservesandSurplusAmount: any;
  LoansfromBank: any;
  DeferredPayment: any
  Depositsaccepted: any;
  LoansandAdvances: any;
  LongTermMaturities: any;
  BondsDebentures: any;
  TotalBorrowingAggregate: any;
  currentURL: any;
  id: any;
  btnValue: any;
  newValue: any;
  checkValidationInput: any;
  companyID: any;
  companyName: any;
  projectKeys: any;
  financialDataDetails: any;
  disabledOnclick: boolean;
  financialDataDisplay = {
    shareCapital: {
      authorizedEquityShareCapital: "",
      authorizedEquityShareCapitalHistory: [],
      authorizedEquityShareCapitalEffectiveDate: "",
      authorizedEquityShareCapitalRemarks: "",

      issuedEquityShareCapital: "",
      issuedEquityShareCapitalHistory: [],
      issuedEquityShareCapitalEffectiveDate: "",
      issuedEquityShareCapitalRemarks: "",

      subscribedEquityShareCapital: "",
      subscribedEquityShareCapitalHistory: [],
      subscribedEquityShareCapitalEffectiveDate: "",
      subscribedEquityShareCapitalRemarks: "",

      paidupEquityShareCapital: "",
      paidupEquityShareCapitalHistory: [],
      paidupEquityShareCapitalEffectiveDate: "",
      paidupEquityShareCapitalRemarks: "",

      authorizedPreferenceShareCapital: "",
      authorizedPreferenceShareCapitalHistory: [],
      authorizedPreferenceShareCapitalEffectiveDate: "",
      authorizedPreferenceShareCapitalRemarks: "",

      issuedPreferenceShareCapital: "",
      issuedPreferenceShareCapitalHistory: [],
      issuedPreferenceShareCapitalEffectiveDate: "",
      issuedPreferenceShareCapitalRemarks: "",

      subscribedPreferenceShareCapital: "",
      subscribedPreferenceShareCapitalHistory: [],
      subscribedPreferenceShareCapitalEffectiveDate: "",
      subscribedPreferenceShareCapitalRemarks: "",

      paidupPreferenceShareCapital: "",
      paidupPreferenceShareCapitalHistory: [],
      paidupPreferenceShareCapitalEffectiveDate: "",
      paidupPreferenceShareCapitalRemarks: "",

      totalPaidUpShareCapital: "",
      totalPaidUpShareCapitalHistory: []
    },
    reservesAndSurplus: {
      generalReserve: "",
      generalReserveHistory: [],
      generalReserveEffectiveDate: "",
      generalReserveRemarks: "",

      surplusProfitAndLoss: "",
      surplusProfitAndLossHistory: [],
      surplusProfitAndLossEffectiveDate: "",
      surplusProfitAndLossRemarks: "",

      debitBalanceofStatementofProfitandLoss: "",
      debitBalanceofStatementofProfitandLossHistory: [],
      debitBalanceofStatementofProfitandLossEffectiveDate: "",
      debitBalanceofStatementofProfitandLossRemarks: "",

      surplusOthers: "",
      surplusOthersHistory: [],
      surplusOthersEffectiveDate: "",
      surplusOthersRemarks: "",

      totalFreeReserve: "",
      totalFreeReserveHistory: [],
      totalFreeReserveEffectiveDate: "",
      totalFreeReserveRemarks: "",

      othersCapitalReserve: "",
      othersCapitalReserveHistory: [],
      othersCapitalReserveEffectiveDate: "",
      othersCapitalReserveRemarks: "",

      capitalReserveProceedsReceivedInCash: "",
      capitalReserveProceedsReceivedInCashHistory: [],
      capitalReserveProceedsReceivedInCashEffectiveDate: "",
      capitalReserveProceedsReceivedInCashRemarks: "",

      capitalReserveProceedsNotReceivedInCash: "",
      capitalReserveProceedsNotReceivedInCashHistory: [],
      capitalReserveProceedsNotReceivedInCashEffectiveDate: "",
      capitalReserveProceedsNotReceivedInCashRemarks: "",

      capitalRedemptionReserve: "",
      capitalRedemptionReserveHistory: [],
      capitalRedemptionReserveEffectiveDate: "",
      capitalRedemptionReserveRemarks: "",

      securityPremiumReserve: "",
      securityPremiumReserveHistory: [],
      securityPremiumReserveEffectiveDate: "",
      securityPremiumReserveRemarks: "",

      totalReservesOtherThanFreeReserves: "",
      totalReservesOtherThanFreeReservesHistory: [],

      totalReservesAndSurplus: "",
      totalReservesAndSurplusHistory: [],

      shareCapitalAndFreeReserves: "",
      shareCapitalAndFreeReservesHistory: [],

      netWorth: "",
      netWorthHistory: [],

      turnover: "",
      turnoverHistory: [],
      turnoverEffectiveDate: "",
      turnoverRemarks: "",

      netProfitForManagerialRemuneration: "",
      netProfitForManagerialRemunerationHistory: [],
      netProfitForManagerialRemunerationEffectiveDate: "",
      netProfitForManagerialRemunerationRemarks: "",

      netProfitForCSRApplicability: "",
      netProfitForCSRApplicabilityHistory: [],
      netProfitForCSRApplicabilityEffectiveDate: "",
      netProfitForCSRApplicabilityRemarks: ""
    },
    loanAndInvestMent: {
      loanGiven: "",
      loanGivenHistory: [],
      loanGivenEffectiveDate: "",
      loanGivenRemarks: "",

      guaranteeOrSecurityGiven: "",
      guaranteeOrSecurityGivenHistory: [],
      guaranteeOrSecurityGivenEffectiveDate: "",
      guaranteeOrSecurityGivenRemarks: "",

      acquisitionOfSecurities: "",
      acquisitionOfSecuritiesHistory: [],
      acquisitionOfSecuritiesEffectiveDate: "",
      acquisitionOfSecuritiesRemarks: "",

      loansOthers: "",
      loansOthersHistory: [],
      loansOthersEffectiveDate: "",
      loansOthersRemarks: "",

      totalLoansAndInvestmentsLimits: "",
      totalLoansAndInvestmentsLimitsHistory: [],
    },
    borrowing: {
      loansfromBankandFinancialInstitutions: "",
      loansfromBankandFinancialInstitutionsHistory: [],
      loansfromBankandFinancialInstitutionsEffectiveDate: "",
      loansfromBankandFinancialInstitutionsRemarks: "",

      deferredPaymentLiabilities: "",
      deferredPaymentLiabilitiesHistory: [],
      deferredPaymentLiabilitiesEffectiveDate: "",
      deferredPaymentLiabilitiesRemarks: "",

      depositsLongTermAndShortTerm: "",
      depositsLongTermAndShortTermHistory: [],
      depositsLongTermAndShortTermEffectiveDate: "",
      depositsLongTermAndShortTermRemarks: "",

      loansandAdvancesfromRelatedParties: "",
      loansandAdvancesfromRelatedPartiesHistory: [],
      loansandAdvancesfromRelatedPartiesEffectiveDate: "",
      loansandAdvancesfromRelatedPartiesRemarks: "",

      longTermMaturitiesofLeaseObligations: "",
      longTermMaturitiesofLeaseObligationsHistory: [],
      longTermMaturitiesofLeaseObligationsEffectiveDate: "",
      longTermMaturitiesofLeaseObligationsRemarks: "",

      bondsAndDebentures: "",
      bondsAndDebenturesHistory: [],
      bondsAndDebenturesEffectiveDate: "",
      bondsAndDebenturesRemarks: "",

      othersBorrowing: "",
      othersBorrowingHistory: [],
      othersBorrowingEffectiveDate: "",
      othersBorrowingRemarks: "",

      totalBorrowing: "",
      totalBorrowingHistory: []
    },
    temporaryLoan: {
      shortTermLoans: "",
      shortTermLoansHistory: [],
      shortTermLoansEffectiveDate: "",
      shortTermLoansRemarks: "",

      cashCreditArrangements: "",
      cashCreditArrangementsHistory: [],
      cashCreditArrangementsEffectiveDate: "",
      cashCreditArrangementsRemarks: "",

      discountingofBiills: "",
      discountingofBiillsHistory: [],
      discountingofBiillsEffectiveDate: "",
      discountingofBiillsRemarks: "",

      otherShortTermLoansofSeasonalCharacter: "",
      otherShortTermLoansofSeasonalCharacterHistory: [],
      otherShortTermLoansofSeasonalCharacterEffectiveDate: "",
      otherShortTermLoansofSeasonalCharacterRemarks: "",

      outstandingLoans: "",
      outstandingLoansLaonHistory: [],
      outstandingLoansEffectiveDate: "",
      outstandingLoansRemarks: "",

      totalTemporaryLoans: "",
      totalTemporaryLoansHistory: [],

      borrowingLimits: "",
      borrowingLimitsHistory: []
    }
  };

  authorizedEquityShareCapitalDtOption: DataTables.Settings = {};
  authorizedEquityShareCapitalDtTrigger: Subject<any> = new Subject();
  issuedEquityShareCapitalDtOption: DataTables.Settings = {};
  issuedEquityShareCapitalDtTrigger: Subject<any> = new Subject();
  subscribedEquityShareCapitalDtOption: DataTables.Settings = {};
  subscribedEquityShareCapitalDtTrigger: Subject<any> = new Subject();
  paidupEquityShareCapitalDtOption: DataTables.Settings = {};
  paidupEquityShareCapitalDtTrigger: Subject<any> = new Subject();
  authorizedPreferenceShareCapitalDtOption: DataTables.Settings = {};
  authorizedPreferenceShareCapitalDtTrigger: Subject<any> = new Subject();
  issuedPreferenceShareCapitalDtOption: DataTables.Settings = {};
  issuedPreferenceShareCapitalDtTrigger: Subject<any> = new Subject();
  subscribedPreferenceShareCapitalDtOption: DataTables.Settings = {};
  subscribedPreferenceShareCapitalDtTrigger: Subject<any> = new Subject();
  paidupPreferenceShareCapitalDtOption: DataTables.Settings = {};
  paidupPreferenceShareCapitalDtTrigger: Subject<any> = new Subject();
  totalPaidUpShareCapitalDtOption: DataTables.Settings = {};
  totalPaidUpShareCapitalDtTrigger: Subject<any> = new Subject();
  generalReserveDtOption: DataTables.Settings = {};
  generalReserveDtTrigger: Subject<any> = new Subject();
  surplusProfitAndLossDtOption: DataTables.Settings = {};
  surplusProfitAndLossDtTrigger: Subject<any> = new Subject();
  debitBalanceofStatementofProfitandLossDtOption: DataTables.Settings = {};
  debitBalanceofStatementofProfitandLossDtTrigger: Subject<any> = new Subject();
  surplusOthersDataTableDtOption: DataTables.Settings = {};
  surplusOthersDataTableDtTrigger: Subject<any> = new Subject();
  totalFreeReservesDtOption: DataTables.Settings = {};
  totalFreeReservesDtTrigger: Subject<any> = new Subject();
  capitalReserveProceedsReceivedInCashDtOption: DataTables.Settings = {};
  capitalReserveProceedsNotReceivedInCashDtTrigger: Subject<any> = new Subject();
  capitalReserveProceedsNotReceivedInCashDtOption: DataTables.Settings = {};
  capitalReserveProceedsReceivedInCashDtTrigger: Subject<any> = new Subject();
  capitalRedemptionReserveDtOption: DataTables.Settings = {};
  capitalRedemptionReserveDtTrigger: Subject<any> = new Subject();
  securityPremiumReserveDtOption: DataTables.Settings = {};
  securityPremiumReserveDtTrigger: Subject<any> = new Subject();
  othersDtOption: DataTables.Settings = {};
  othersDtTrigger: Subject<any> = new Subject();
  totalReservesOtherThanFreeReservesDtOption: DataTables.Settings = {};
  totalReservesOtherThanFreeReservesDtTrigger: Subject<any> = new Subject();
  totalReservesAndSurplusDtOption: DataTables.Settings = {};
  totalReservesAndSurplusDtTrigger: Subject<any> = new Subject();
  shareCapitalAndFreeReservesDtOption: DataTables.Settings = {};
  shareCapitalAndFreeReservesDtTrigger: Subject<any> = new Subject();
  netWorthDtOption: DataTables.Settings = {};
  netWorthDtTrigger: Subject<any> = new Subject();
  turnoverDtOption: DataTables.Settings = {};
  turnoverDtTrigger: Subject<any> = new Subject();
  netProfitForManagerialRemunerationDtOption: DataTables.Settings = {};
  netProfitForManagerialRemunerationDtTrigger: Subject<any> = new Subject();
  netProfitForCSRApplicabilityDtOption: DataTables.Settings = {};
  netProfitForCSRApplicabilityDtTrigger: Subject<any> = new Subject();
  loanGivenDtOption: DataTables.Settings = {};
  loanGivenDtTrigger: Subject<any> = new Subject();
  guaranteeOrSecurityGivenDtOption: DataTables.Settings = {};
  guaranteeOrSecurityGivenDtTrigger: Subject<any> = new Subject();
  acquisitionOfSecuritiesDtOption: DataTables.Settings = {};
  acquisitionOfSecuritiesDtTrigger: Subject<any> = new Subject();
  loansOthersDtOption: DataTables.Settings = {};
  loansOthersDtTrigger: Subject<any> = new Subject();
  totalLoansAndInvestmentsLimitsDtOption: DataTables.Settings = {};
  totalLoansAndInvestmentsLimitsDtTrigger: Subject<any> = new Subject();
  loansfromBankandFinancialInstitutionsDtOption: DataTables.Settings = {};
  loansfromBankandFinancialInstitutionsDtTrigger: Subject<any> = new Subject();
  deferredPaymentLiabilitiesDtOption: DataTables.Settings = {};
  deferredPaymentLiabilitiesDtTrigger: Subject<any> = new Subject();
  depositsLongTermAndShortTermDtOption: DataTables.Settings = {};
  depositsLongTermAndShortTermDtTrigger: Subject<any> = new Subject();
  loansandAdvancesfromRelatedPartiesDtOption: DataTables.Settings = {};
  loansandAdvancesfromRelatedPartiesDtTrigger: Subject<any> = new Subject();
  longTermMaturitiesofLeaseObligationsDtOption: DataTables.Settings = {};
  longTermMaturitiesofLeaseObligationsDtTrigger: Subject<any> = new Subject();
  bondsAndDebenturesDtOption: DataTables.Settings = {};
  bondsAndDebenturesDtTrigger: Subject<any> = new Subject();
  othersBorrowingDtOption: DataTables.Settings = {};
  othersBorrowingDtTrigger: Subject<any> = new Subject();
  totalBorrowingDtOption: DataTables.Settings = {};
  totalBorrowingDtTrigger: Subject<any> = new Subject();
  shortTermLoansDtOption: DataTables.Settings = {};
  shortTermLoansDtTrigger: Subject<any> = new Subject();
  cashCreditArrangementsDtOption: DataTables.Settings = {};
  cashCreditArrangementsDtTrigger: Subject<any> = new Subject();
  discountingofBiillsDtOption: DataTables.Settings = {};
  discountingofBiillsDtTrigger: Subject<any> = new Subject();
  otherShortTermLoansofSeasonalCharacterDtOption: DataTables.Settings = {};
  otherShortTermLoansofSeasonalCharacterDtTrigger: Subject<any> = new Subject();
  outstandingLoansLaonDtOption: DataTables.Settings = {};
  outstandingLoansLaonDtTrigger: Subject<any> = new Subject();
  totalTemporaryLoansDtOption: DataTables.Settings = {};
  totalTemporaryLoansDtTrigger: Subject<any> = new Subject();
  borrowingLimitsDtOption: DataTables.Settings = {};
  borrowingLimitsDtTrigger: Subject<any> = new Subject();

  constructor(private alert: AlertComponent,
    private companyMasterService: AddCompanyDetailsService,
    private financeServiceRelatedCompany: FinanceServicesService,
    private router: Router,
    private commonFunction: CommonFunction,private route: ActivatedRoute, private loaderService: LoaderService) {
  }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit() {
    this.loaderService.disable();
    this.environmentSettings = environment;
    localStorage.setItem('checktab', '');
    var checktabstring = localStorage.getItem('checktab')
    this.activeclassflag = checktabstring.includes("checktab");

    this.setCompnayDetails();
    // this.getCompanyIncorporationDate();
    const self = this;
    // this.getCompanyIncorporationDate(function (response) {
    //   var dateOfIncorporation = new Date(this.setFormatDate(response.CompanyDetails[0].DateOfIncorporation));
    //   this.globalIncorporationYear = dateOfIncorporation.getFullYear();
    // });
    this.showSelected = false;
    this.currentURL = window.location.href;
    this.checkValidationInput = false;
    // this.financialDataForm.controls.FinancialYear.setValue(financialYearID);
    if (this.currentURL.indexOf("add") !== -1) {
      this.addNewFinancialDetails();
      this.btnValue = 'Save';
    } else {
      this.get();
      this.btnValue = 'Update';
    }
    //this.get();

    this.dtOptions = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      // order: [],
      // columnDefs: [ { orderable: false, targets: [17]}]
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]]
    };

    this.financialDataForm = new FormGroup({
      FinancialYear: new FormControl('', [Validators.required]),
      authorizedEquityShareCapital: new FormControl('', []),
      issuedEquityShareCapital: new FormControl('', []),
      subscribedShareCapital: new FormControl('', []),
      paidupEquityShareCapital: new FormControl('', []),
      authorizedPreferenceShareCapital: new FormControl('', []),
      issuedPreferenceShareCapital: new FormControl('', []),
      subscribedPreferenceShareCapital: new FormControl('', []),
      paidupPreferenceShareCapital: new FormControl('', []),
      generalReserve: new FormControl('', []),
      surplus: new FormControl('', []),
      debitBalanceofStatementofProfitandLoss: new FormControl('', []),
      SurplusOthers: new FormControl('', []),
      CapitalReserveCash: new FormControl('', []),
      capitalReserveNotCash: new FormControl('', []),
      // freeReserveOthers: new FormControl('', []),
      netWorth: new FormControl('', []),
      managerialRemunerationNetProfit: new FormControl('', []),
      cSRApplicabilityNetProfit: new FormControl('', []),
      loanGiven: new FormControl('', []),
      securityofLoan: new FormControl('', []),
      acquisitionCost: new FormControl('', []),
      loansOthers: new FormControl('', []),
      typeOfIndustry: new FormControl('', []),
      loansfromBankandFinancialInstitutions: new FormControl('', []),
      deferredPaymentLiabilities: new FormControl('', []),
      deposits: new FormControl('', []),
      loansandAdvancesfromRelatedParties: new FormControl('', []),
      longTermMaturitiesofLeaseObligations: new FormControl('', []),
      shortTermLoans: new FormControl('', []),
      cashCreditArrangements: new FormControl('', []),
      discountingofBills: new FormControl('', []),
      otherShortTermLoansofSeasonalCharacter: new FormControl('', []),
      outstandingLoans: new FormControl('', []),
      capitalRedemptionReserve: new FormControl('', []),
      securityPremiumReserve: new FormControl('', []),
      turnover: new FormControl('', []),
      bondsDebentures: new FormControl('', []),
      // tempLoanOthers: new FormControl('', []),
      borrowOthers: new FormControl('', []),
      totalFreeReserve: new FormControl('', []),
      // totalReserveSurplus: new FormControl('', []),
      totalPaid: new FormControl('', []),
      // totalFreeReserves: new FormControl('', []),

      otherthanfreeReserves: new FormControl('', []),
      totalReservesandSurplus: new FormControl('', []),
      shareCapitalandFreeReserves: new FormControl('', []),
      others: new FormControl('', []),
      totalLoansandInvestments: new FormControl('', []),
      totalBorrowing: new FormControl('', []),
      totalTemporaryLoans: new FormControl('', []),
      borrowing: new FormControl('', []),
      OthersCapitalReserve: new FormControl('', []),
      othersBorrowing: new FormControl('', [])
    }
    );

    // let financialYearID =  localStorage.getItem("financialYearID");
    // console.log('hello', financialYearID);    
    // this.financialDataForm.controls.FinancialYear.setValue(financialYearID);

    this.financialDataForm.controls.FinancialYear.setValue('');
  }


  onKeyPress(event: KeyboardEvent) {
    const allowedChars = /[0-9\.]/g;
    const inputChar = String.fromCharCode(event.charCode);
    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }
  getCompaniesList() {
    this.companies = [];
    this.companyMasterService.getCompanyList()
      .subscribe(companies => {
        if (companies.status == 0) {
          this.companies = companies.companyList;
          this.dtTrigger.next();
        }
      })
  }

  //show Add compnay master pop up
  showAddPopUp() {
    $("#myModalLabel").text("Add Company Master");
    $('#btnsaveCompany').show();
    $('#btnupdateCompany').hide();
    this.companyMasterForm.reset();
    this.error = { isError: false, errorMessage: '' }
    this.companyId = ""; //reset companyId
    this.selectedPeers = [];
    this.peersList = [];
    this.chosenPeers = [];
    this.companyNameModel = "";
  }

  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }



  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  ResetCompanyForm() {
    this.companyMasterForm.reset();
    this.selectedPeers = [];
    this.invalidPeers = false;
  }

  back() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['company', 'financeDetails']  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/company/financeDetails']);
    this.financialDataForm.reset();
  }

  financialYearValidation() {
    let projectKey = $("#projectKey").val();
    this.projectKeys = projectKey;

  }

  // calculation of reserve and serplus of Reserve and surplus tab
  reserveAndSerlusTotalFreeReserves() {
    let totalPaid = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalPaid.value);
    let reverse = $("#reverse").val();
    let surplus = $("#surplus").val();
    let debitBalance = $("#debitBalance").val();
    let surplusOthers = $("#surplusOthers").val();
    if (reverse == "") { reverse = 0; }
    if (surplus == "") { surplus = 0; }
    if (debitBalance == "") { debitBalance = 0; }
    if (surplusOthers == "" || surplusOthers == 0) { surplusOthers = 0; }

    let totalFreeReserve = this.convertCommaSeparatedToNumber(reverse) + this.convertCommaSeparatedToNumber(surplus) -
      this.convertCommaSeparatedToNumber(debitBalance) + this.convertCommaSeparatedToNumber(surplusOthers);
    $("#total").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalFreeReserve)))
    this.financialDataForm.controls.totalFreeReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalFreeReserve)));

    let capitalReserve = $("#capitalReserve").val();
    let capitalReserveNotCash = $("#capitalReserveNotCash").val();
    let capitalRedemptionReserve = $("#capitalRedemptionReserve").val();
    let securityPremiumReserve = $("#securityPremiumReserve").val();
    let others = $("#others").val();
    if (capitalReserve == "") { capitalReserve = 0; }
    if (capitalReserveNotCash == "") { capitalReserveNotCash = 0; }
    if (capitalRedemptionReserve == "") { capitalRedemptionReserve = 0; }
    if (securityPremiumReserve == "") { securityPremiumReserve = 0; }
    if (others == "") { others = 0; }

    let otherthanfreeReservesValue = this.convertCommaSeparatedToNumber(capitalReserve) + this.convertCommaSeparatedToNumber(capitalReserveNotCash) +
      this.convertCommaSeparatedToNumber(capitalRedemptionReserve) + this.convertCommaSeparatedToNumber(securityPremiumReserve) +
      this.convertCommaSeparatedToNumber(others)
    $("#otherthanfreeReserves").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(otherthanfreeReservesValue)))
    this.financialDataForm.controls.otherthanfreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(otherthanfreeReservesValue)));

    //Total Reserves and Surplus 
    let otherthanfreeReserves = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.otherthanfreeReserves.value);
    let total = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalFreeReserve.value);
    if (otherthanfreeReserves == "") { otherthanfreeReserves = 0; }
    if (total == "") { total = 0; }
    $("#totalReservesandSurplus").val(parseFloat(total) + parseFloat(otherthanfreeReserves));
    let totalReservesAndSurplus = parseFloat(total) + parseFloat(otherthanfreeReserves);
    this.financialDataForm.controls.totalReservesandSurplus.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalReservesAndSurplus)));
    //Share Capital and Free Reserves
    let totalPaidUpShareCapital = $("#totalPaidUpShareCapital").val();
    // let totalPaidUpShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalPaid.value);
    let totalValue = $("#total").val();
    if (totalPaidUpShareCapital == "") { totalPaidUpShareCapital = 0; }
    if (totalValue == "") { totalValue = 0; }
    let shareCapitalandFreeReserve = this.convertCommaSeparatedToNumber(totalPaid) + this.convertCommaSeparatedToNumber(totalValue);
    $("#shareCapitalandFreeReserve").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(shareCapitalandFreeReserve)))
    this.financialDataForm.controls.shareCapitalandFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(shareCapitalandFreeReserve)));
    //Net Worth
    let totalResurvSurplus = $("#totalReservesandSurplus").val();
    let netWorth = this.convertCommaSeparatedToNumber(totalResurvSurplus) + this.convertCommaSeparatedToNumber(totalPaid);
    $("#netWorth").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(netWorth)))
    this.financialDataForm.controls.netWorth.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(netWorth)));
  }

  // calculation of  barrowing amount borrowing tab
  borrowingAmount() {
    var longTermMaturities = $("#longTermMaturities").val();
    var loansandAdvances = $("#loansandAdvances").val();
    var deposits = $("#deposits").val();
    var deferredPayment = $("#deferredPayment").val();
    var loansfromBank = $("#loansfromBank").val();
    var bondsDebentures = $("#bondsDebentures").val();
    var others = $("#others").val();
    if (longTermMaturities == "") { longTermMaturities = 0; };
    if (loansandAdvances == "") { loansandAdvances = 0; }
    if (deposits == "") { deposits = 0; }
    if (deferredPayment == "") { deferredPayment = 0; }
    if (loansfromBank == "") { loansfromBank = 0; }
    if (bondsDebentures == "") { bondsDebentures = 0; }
    if (others == "") { others = 0; }

    let totalBorrowing = this.convertCommaSeparatedToNumber(longTermMaturities) + this.convertCommaSeparatedToNumber(loansandAdvances) +
      this.convertCommaSeparatedToNumber(deposits) + this.convertCommaSeparatedToNumber(deferredPayment) +
      this.convertCommaSeparatedToNumber(loansfromBank) + this.convertCommaSeparatedToNumber(others) +
      this.convertCommaSeparatedToNumber(bondsDebentures)
    $("#totalBorrowing").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalBorrowing)))
    this.financialDataForm.controls.totalBorrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalBorrowing)));
    var totalTemporaryLoans = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalTemporaryLoans.value) || 0;
    let borrowingLimitsUS180 = this.convertCommaSeparatedToNumber(totalBorrowing) - this.convertCommaSeparatedToNumber(totalTemporaryLoans);
    this.financialDataForm.controls.borrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(borrowingLimitsUS180)));
  }

  calculateRoundedTwoDecimal(theform) {
    let decimalOnlyTwoNumber = theform.toString().match(/^-?\d+(?:\.\d{0,2})?/)
    return decimalOnlyTwoNumber;
  }

  numberWithCommas(numberWithcomma) {
    let variable = numberWithcomma.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return variable;
  }

  // calculation of  loan amount  loan and investment tab
  loanAndInvestMent() {

    var loansOthersAmount = $("#loansOthersAmount").val();
    var acquisitionAmount = $("#acquisitionAmount").val();
    var guaranteeAmount = $("#guaranteeAmount").val();
    var loanGiven = $("#loanGiven").val();

    if (loansOthersAmount == "") { loansOthersAmount = 0; };
    if (acquisitionAmount == "") { acquisitionAmount = 0; }
    if (guaranteeAmount == "") { guaranteeAmount = 0; }
    if (loanGiven == "") { loanGiven = 0; }

    let totalAmount = this.convertCommaSeparatedToNumber(loansOthersAmount) + this.convertCommaSeparatedToNumber(acquisitionAmount) +
      this.convertCommaSeparatedToNumber(guaranteeAmount) + this.convertCommaSeparatedToNumber(loanGiven);
    $("#totalLoansandInvestment").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalAmount)))
    this.financialDataForm.controls.totalLoansandInvestments.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalAmount)));
  }

  // calculation of temporary loan amount  loan and investment tab
  temporaryLoansAmount() {

    let totalBorrowing = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalBorrowing.value);
    var shortTermLoans = $("#shortTermLoans").val();
    var cashCreditArrangements = $("#cashCreditArrangements").val();
    var discountingofBills = $("#discountingofBills").val();
    var otherShortTermLoansofSeasonalCharacter = $("#otherShortTermLoansofSeasonalCharacter").val();
    var outstandingLoans = $("#outstandingLoans").val();

    if (shortTermLoans == "") { shortTermLoans = 0; };
    if (cashCreditArrangements == "") { cashCreditArrangements = 0; }
    if (discountingofBills == "") { discountingofBills = 0; }
    if (otherShortTermLoansofSeasonalCharacter == "") { otherShortTermLoansofSeasonalCharacter = 0; }
    if (outstandingLoans == "") { outstandingLoans = 0; }

    let totalAmount = this.convertCommaSeparatedToNumber(shortTermLoans) + this.convertCommaSeparatedToNumber(cashCreditArrangements) +
      this.convertCommaSeparatedToNumber(discountingofBills) + this.convertCommaSeparatedToNumber(otherShortTermLoansofSeasonalCharacter) +
      this.convertCommaSeparatedToNumber(outstandingLoans);
    let totalshortAndCash = this.convertCommaSeparatedToNumber(totalBorrowing) - this.convertCommaSeparatedToNumber(totalAmount);
    $("#borrowing").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalshortAndCash)));
    $("#totalTemporaryLoans").val(this.commonFunction.formatToCommaSeperatedNumber(totalAmount.toFixed(0)))
    this.financialDataForm.controls.totalTemporaryLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(totalAmount.toFixed(0)));
    this.financialDataForm.controls.borrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalshortAndCash)));

  }

  // calculation of total paid amount of share capital tab
  paidCalculationAmount() {

    let paidupEquity = $("#paidupEquity").val();
    let paidupPreference = $("#paidupPreference").val();
    if (paidupEquity == "") { paidupEquity = 0; };
    if (paidupPreference == "") { paidupPreference = 0; }
    let totalAmount = this.convertCommaSeparatedToNumber(paidupEquity) + this.convertCommaSeparatedToNumber(paidupPreference);
    $("#totlapaid").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalAmount)))
    this.financialDataForm.controls.totalPaid.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalAmount)));

    //shareCapitalandFreeReserve
    var totalFreeReserve = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalFreeReserve.value) || 0;
    let shareAndFreeReserve = this.convertCommaSeparatedToNumber(totalAmount) + this.convertCommaSeparatedToNumber(totalFreeReserve);
    this.financialDataForm.controls.shareCapitalandFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(shareAndFreeReserve)));

    //netwoth
    var totalReservesandSurplus = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalReservesandSurplus.value) || 0;
    let netWorth = this.convertCommaSeparatedToNumber(totalReservesandSurplus) + this.convertCommaSeparatedToNumber(totalAmount);
    this.financialDataForm.controls.netWorth.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(netWorth)));
  }

  convertCommaSeparatedToNumber(number) {

    let convertNumber = number.toString().replace(/\,/g, '');
    if (convertNumber != '') {
      let convertedNumber = parseFloat(convertNumber);
      return convertedNumber;
    }
  }

  /**
   * function to  get Financial data  By Selected Year
   */
  get() {
    console.log("getttt");

    this.financialYears = [];
    this.financeServiceRelatedCompany.getCompanyIncorporationDate()
      .subscribe(companyDetails => {
        if (companyDetails.status == 0) {
          var dateOfIncorporation = new Date(this.setFormatDate(companyDetails.CompanyDetails[0].DateOfIncorporation));
          this.globalIncorporationYear = dateOfIncorporation.getFullYear();
          for (var i = this.globalIncorporationYear; i < 2025; i++) {
            this.financialYears.push({ "name": i + "-" + (i + 1) % 100 });
          }
        }
      });
    this.newValue = "";
    var financialID = localStorage.getItem('financialID');
    this.companyMasterService.getfinancialData(financialID).subscribe((data:any) => {

      this.financialDataList = data.financeDetail[0];
      this.financialDataForm.controls.FinancialYear.setValue(this.financialDataList.FinancialYear);
      this.financialDataForm.controls.authorizedEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.AuthorizedEquityShareCapital));
      this.financialDataForm.controls.issuedEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.IssuedEquityShareCapital));
      this.financialDataForm.controls.subscribedShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SubscribedShareCapital));
      this.financialDataForm.controls.paidupEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.PaidupEquityShareCapital));
      this.financialDataForm.controls.authorizedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.AuthorizedPreferenceShareCapital));
      this.financialDataForm.controls.issuedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.IssuedPreferenceShareCapital));
      this.financialDataForm.controls.subscribedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SubscribedPreferenceShareCapital));
      this.financialDataForm.controls.paidupPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.PaidupPreferenceShareCapital));
      this.financialDataForm.controls.generalReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.GeneralReserve));
      this.financialDataForm.controls.surplus.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.Surplus));
      this.financialDataForm.controls.debitBalanceofStatementofProfitandLoss.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.DebitBalanceofStatementofProfitandLoss));
      this.financialDataForm.controls.SurplusOthers.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SurplusOthers));
      this.financialDataForm.controls.OthersCapitalReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OthersCapitalReserve));
      this.financialDataForm.controls.CapitalReserveCash.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CapitalReserveCash));
      this.financialDataForm.controls.capitalReserveNotCash.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CapitalReserveNotCash));
      this.financialDataForm.controls.netWorth.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.NetWorth));
      this.financialDataForm.controls.managerialRemunerationNetProfit.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.ManagerialRemunerationNetProfit));
      this.financialDataForm.controls.cSRApplicabilityNetProfit.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CSRApplicabilityNetProfit));
      this.financialDataForm.controls.loanGiven.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LoanGiven));
      this.financialDataForm.controls.securityofLoan.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SecurityofLoan));
      this.financialDataForm.controls.acquisitionCost.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.AcquisitionCost));
      this.financialDataForm.controls.loansOthers.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LoansOthers));
      this.financialDataForm.controls.loansfromBankandFinancialInstitutions.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LoansfromBankandFinancialInstitutions));
      this.financialDataForm.controls.deferredPaymentLiabilities.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.DeferredPaymentLiabilities));
      this.financialDataForm.controls.deposits.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.Deposits));
      this.financialDataForm.controls.loansandAdvancesfromRelatedParties.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LoansandAdvancesfromRelatedParties));
      this.financialDataForm.controls.longTermMaturitiesofLeaseObligations.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LongTermMaturitiesofLeaseObligations));
      this.financialDataForm.controls.shortTermLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.ShortTermLoans));
      this.financialDataForm.controls.cashCreditArrangements.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CashCreditArrangements));
      this.financialDataForm.controls.discountingofBills.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.DiscountingofBills));
      this.financialDataForm.controls.otherShortTermLoansofSeasonalCharacter.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OtherShortTermLoansofSeasonalCharacter));
      this.financialDataForm.controls.outstandingLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OutstandingLoans));
      this.financialDataForm.controls.capitalRedemptionReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CapitalRedemptionReserve));
      this.financialDataForm.controls.securityPremiumReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SecurityPremiumReserve));
      this.financialDataForm.controls.turnover.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.Turnover));
      this.financialDataForm.controls.bondsDebentures.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.BondsDebentures));
      this.financialDataForm.controls.borrowOthers.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.BorrowOthers));
      this.financialDataForm.controls.totalFreeReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalFreeReserve));
      this.financialDataForm.controls.otherthanfreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OtherthanfreeReserves));
      this.financialDataForm.controls.totalReservesandSurplus.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalReservesandSurplus));
      this.financialDataForm.controls.othersBorrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OthersBorrowing));
      this.financialDataForm.controls.totalTemporaryLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalTemporaryLoansAmount));
      this.financialDataForm.controls.shareCapitalandFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.ShareCapitalandFreeReserves));
      this.financialDataForm.controls.totalPaid.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalPaidUpShareCapital));
      if (this.financialDataList.AcquisitionCost || this.financialDataList.LoansOthers
        || this.financialDataList.SecurityofLoan || this.financialDataList.LoanGiven) {
        let acquisitionCosts = this.financialDataList.AcquisitionCost;
        let loansOthers = this.financialDataList.LoansOthers;
        let securityofLoan = this.financialDataList.SecurityofLoan;
        let loanGiven = this.financialDataList.LoanGiven;
        let shareCapitalFree = acquisitionCosts + loansOthers + securityofLoan + loanGiven;
        this.financialDataForm.controls.totalLoansandInvestments.setValue(this.commonFunction.formatToCommaSeperatedNumber(shareCapitalFree));
      }
      if (this.financialDataList.AcquisitionCost || this.financialDataList.LoansOthers
        || this.financialDataList.SecurityofLoan || this.financialDataList.LoanGiven) {
        let acquisitionCosts = this.financialDataList.AcquisitionCost;
        let loansOthers = this.financialDataList.LoansOthers;
        let securityofLoan = this.financialDataList.SecurityofLoan;
        let loanGiven = this.financialDataList.LoanGiven;
        let shareCapitalFree = acquisitionCosts + loansOthers + securityofLoan + loanGiven;
        this.financialDataForm.controls.totalLoansandInvestments.setValue(this.commonFunction.formatToCommaSeperatedNumber(shareCapitalFree));
      }
      this.financialDataForm.controls.totalBorrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalBorrowingAmount));
      this.financialDataForm.controls.borrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.BorrowingLimitsUS180));
    });
  }

  selectPickerChange() {


    this.getFinanceBySelectedYear();
    // this.currentURL = window.location.href;

    // if (this.currentURL.indexOf("add") !== -1) {
    //   this.addNewFinancialDetails();
    //   this.btnValue = 'Save';
    // } else {
    //   this.getFinanceBySelectedYear();
    //   this.btnValue = 'Update';
    // }
  }

  /**
   * function to add financial data
   */
  addNewFinancialDetails() {
    this.financialYears = [];
    this.financeServiceRelatedCompany.getCompanyIncorporationDate()
      .subscribe(companyDetails => {
        if (companyDetails.status == 0) {
          if (companyDetails.CompanyDetails[0].DateOfIncorporation != null) {
            var dateOfIncorporation = new Date(this.setFormatDate(companyDetails.CompanyDetails[0].DateOfIncorporation));
            this.globalIncorporationYear = dateOfIncorporation.getFullYear();
            for (var i = this.globalIncorporationYear; i < new Date().getFullYear() + 1; i++) {
              let appendyear = (i + 1) % 100;
              var lappendyear;
              if (appendyear.toString().length == 1) {
                 lappendyear = 0 + appendyear.toString();
              }
              else {
                 lappendyear = appendyear;
              }
              this.financialYears.push({ "name": i + "-" + lappendyear });
            }
          }
          else {
            this.financialYears.push({ "name": new Date().getFullYear() + "-" + (new Date().getFullYear() + 1) % 100 });
          }

          this.financialYears.reverse();

        }
      });
  }

  /**
   * function to  get Financial data  By Selected Year
   */
  getFinanceBySelectedYear() {
    var financialYear = this.financialDataForm.controls.FinancialYear.value;

    if (financialYear) {
      this.companyMasterService.getFinanceBySelectedYear(financialYear).subscribe((data:any) => {

        if (data.financeDetail.length === 0) {
          this.financialDataForm.reset();
          this.financialDataForm.controls.FinancialYear.setValue(financialYear);
          var splitFinacialYear = financialYear.split("-")[0];
          {
            var getPassFinancialYear = '';
            getPassFinancialYear = splitFinacialYear - 1 + "-" + (splitFinacialYear) % 100;
            this.companyMasterService.getFinanceBySelectedYear(getPassFinancialYear).subscribe((data:any) => {
              if (data.financeDetail.length > 0) {
                console.log('data.financeDetail', data.financeDetail);

                this.financialDataList = data.financeDetail[0];
                console.log(this.financialDataList);
                this.financialDataForm.controls.FinancialYear.setValue(financialYear);

                console.log("888888888888",financialYear);

                this.financialDataForm.controls.authorizedEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.AuthorizedEquityShareCapital.value));
                this.financialDataForm.controls.issuedEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.IssuedEquityShareCapital.value));
                this.financialDataForm.controls.subscribedShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SubscribedShareCapital.value));
                this.financialDataForm.controls.paidupEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.PaidupEquityShareCapital.value));
                this.financialDataForm.controls.authorizedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.AuthorizedPreferenceShareCapital.value));
                this.financialDataForm.controls.issuedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.IssuedPreferenceShareCapital.value));
                this.financialDataForm.controls.subscribedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SubscribedPreferenceShareCapital.value));
                this.financialDataForm.controls.paidupPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.PaidupPreferenceShareCapital.value));
                this.financialDataForm.controls.generalReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.GeneralReserve.value));
                this.financialDataForm.controls.surplus.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.Surplus.value));
                this.financialDataForm.controls.debitBalanceofStatementofProfitandLoss.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.DebitBalanceofStatementofProfitandLoss.value));
                this.financialDataForm.controls.SurplusOthers.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SurplusOthers.value));
                this.financialDataForm.controls.OthersCapitalReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OthersCapitalReserve.value));
                this.financialDataForm.controls.CapitalReserveCash.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CapitalReserveCash.value));
                this.financialDataForm.controls.capitalReserveNotCash.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CapitalReserveNotCash.value));
                this.financialDataForm.controls.netWorth.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.NetWorth.value));
                this.financialDataForm.controls.managerialRemunerationNetProfit.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.ManagerialRemunerationNetProfit.value));
                this.financialDataForm.controls.cSRApplicabilityNetProfit.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CSRApplicabilityNetProfit));
                this.financialDataForm.controls.loanGiven.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LoanGiven.value));
                this.financialDataForm.controls.securityofLoan.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SecurityofLoan.value));
                this.financialDataForm.controls.acquisitionCost.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.AcquisitionCost.value));
                this.financialDataForm.controls.loansOthers.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LoansOthers.value));
                this.financialDataForm.controls.loansfromBankandFinancialInstitutions.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LoansfromBankandFinancialInstitutions.value));
                this.financialDataForm.controls.deferredPaymentLiabilities.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.DeferredPaymentLiabilities.value));
                this.financialDataForm.controls.deposits.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.Deposits.value));
                this.financialDataForm.controls.loansandAdvancesfromRelatedParties.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LoansandAdvancesfromRelatedParties.value));
                this.financialDataForm.controls.longTermMaturitiesofLeaseObligations.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.LongTermMaturitiesofLeaseObligations));
                this.financialDataForm.controls.shortTermLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.ShortTermLoans.value));
                this.financialDataForm.controls.cashCreditArrangements.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CashCreditArrangements.value));
                this.financialDataForm.controls.discountingofBills.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.DiscountingofBills.value));
                this.financialDataForm.controls.otherShortTermLoansofSeasonalCharacter.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OtherShortTermLoansofSeasonalCharacter.value));
                this.financialDataForm.controls.outstandingLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OutstandingLoans.value));
                this.financialDataForm.controls.capitalRedemptionReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.CapitalRedemptionReserve.value));
                this.financialDataForm.controls.securityPremiumReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.SecurityPremiumReserve.value));
                this.financialDataForm.controls.turnover.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.Turnover.value));
                this.financialDataForm.controls.bondsDebentures.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.BondsDebentures.value));
                this.financialDataForm.controls.borrowOthers.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.BorrowOthers.value));
                this.financialDataForm.controls.totalFreeReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalFreeReserve.value));
                this.financialDataForm.controls.otherthanfreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OtherthanfreeReserves.value));
                this.financialDataForm.controls.totalReservesandSurplus.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalReservesandSurplus.value));
                this.financialDataForm.controls.othersBorrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.OthersBorrowing.value));
                this.financialDataForm.controls.totalTemporaryLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalTemporaryLoansAmount.value));
                this.financialDataForm.controls.shareCapitalandFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.ShareCapitalandFreeReserves.value));
                this.financialDataForm.controls.totalPaid.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalPaidUpShareCapital.value));
                if (this.financialDataList.AcquisitionCost.value || this.financialDataList.LoansOthers.value
                  || this.financialDataList.SecurityofLoan.value || this.financialDataList.LoanGiven.value) {
                  let acquisitionCosts = this.financialDataList.AcquisitionCost.value;
                  let loansOthers = this.financialDataList.LoansOthers.value;
                  let securityofLoan = this.financialDataList.SecurityofLoan.value;
                  let loanGiven = this.financialDataList.LoanGiven.value;
                  let shareCapitalFree = acquisitionCosts + loansOthers + securityofLoan + loanGiven;
                  this.financialDataForm.controls.totalLoansandInvestments.setValue(this.commonFunction.formatToCommaSeperatedNumber(shareCapitalFree));
                }
                if (this.financialDataList.AcquisitionCost.value || this.financialDataList.LoansOthers.value
                  || this.financialDataList.SecurityofLoan.value || this.financialDataList.LoanGiven.value) {
                  let acquisitionCosts = this.financialDataList.AcquisitionCost;
                  let loansOthers = this.financialDataList.LoansOthers;
                  let securityofLoan = this.financialDataList.SecurityofLoan;
                  let loanGiven = this.financialDataList.LoanGiven;
                  let shareCapitalFree = acquisitionCosts + loansOthers + securityofLoan + loanGiven;
                  this.financialDataForm.controls.totalLoansandInvestments.setValue(this.commonFunction.formatToCommaSeperatedNumber(shareCapitalFree));
                }
                this.financialDataForm.controls.totalBorrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.TotalBorrowingAmount.value));
                this.financialDataForm.controls.borrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.financialDataList.BorrowingLimitsUS180.value));
              }
              else {
                return true;
              }
            });
          }
        }
        else {
          this.financialDataList = data.financeDetail[0];
          var id = this.financialDataList._id;
          this.router.navigate(
            [{ outlets: { 'structure-outlet': ['company', 'financeDetails','edit',id]  } }],
            { relativeTo: this.route.parent });
          // this.router.navigate(['company/financeDetails/edit', id]);
        }
      });
    }
  }
  /**
    * function to add or update financial data
    */
  financialData() {
    this.disabledOnclick = true;
    var loginUsers = JSON.parse(localStorage.getItem('companyDetails'));

    var addFinancialData = {
      CompanyID: loginUsers.companyID,
      FinancialYear: this.financialDataForm.controls.FinancialYear.value,
      AuthorizedEquityShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.authorizedEquityShareCapital.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      IssuedEquityShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.issuedEquityShareCapital.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      SubscribedShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.subscribedShareCapital.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      PaidupEquityShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.paidupEquityShareCapital.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      AuthorizedPreferenceShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.authorizedPreferenceShareCapital.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      IssuedPreferenceShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.issuedPreferenceShareCapital.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      SubscribedPreferenceShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.subscribedPreferenceShareCapital.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      PaidupPreferenceShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.paidupPreferenceShareCapital.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      GeneralReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.generalReserve.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      Surplus: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.surplus.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      DebitBalanceofStatementofProfitandLoss: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.debitBalanceofStatementofProfitandLoss.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      SurplusOthers: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.SurplusOthers.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      OthersCapitalReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.OthersCapitalReserve.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      TotalFreeReserves: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalFreeReserve.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      CapitalReserveCash: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.CapitalReserveCash.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      CapitalReserveNotCash: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.capitalReserveNotCash.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      NetWorth: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.netWorth.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      ManagerialRemunerationNetProfit: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.managerialRemunerationNetProfit.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      CSRApplicabilityNetProfit: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.cSRApplicabilityNetProfit.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      LoanGiven: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.loanGiven.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      SecurityofLoan: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.securityofLoan.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      AcquisitionCost: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.acquisitionCost.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      LoansOthers: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.loansOthers.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      LoansfromBankandFinancialInstitutions: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.loansfromBankandFinancialInstitutions.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      TotalLoansAndInvestmentsLimits: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalLoansandInvestments.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      DeferredPaymentLiabilities: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.deferredPaymentLiabilities.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      Deposits: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.deposits.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      LoansandAdvancesfromRelatedParties: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.loansandAdvancesfromRelatedParties.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      LongTermMaturitiesofLeaseObligations: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.longTermMaturitiesofLeaseObligations.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      ShortTermLoans: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.shortTermLoans.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      CashCreditArrangements: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.cashCreditArrangements.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      DiscountingofBills: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.discountingofBills.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      OtherShortTermLoansofSeasonalCharacter: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.otherShortTermLoansofSeasonalCharacter.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      OutstandingLoans: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.outstandingLoans.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      CapitalRedemptionReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.capitalRedemptionReserve.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      SecurityPremiumReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.securityPremiumReserve.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      Turnover: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.turnover.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      BondsDebentures: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.bondsDebentures.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      TotalPaidUpShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalPaid.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      BorrowOthers: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.borrowOthers.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      TotalFreeReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalFreeReserve.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      OtherthanfreeReserves: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.otherthanfreeReserves.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      TotalReservesandSurplus: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalReservesandSurplus.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      OthersBorrowing: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.othersBorrowing.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      TotalBorrowingAmount: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalBorrowing.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      TotalTemporaryLoansAmount: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalTemporaryLoans.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      BorrowingLimitsUS180: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.borrowing.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
      ShareCapitalandFreeReserves: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.shareCapitalandFreeReserves.value),
        EffectiveDate: new Date(),
        Remarks: null
      },
    }

    this.companyMasterService.financialData(addFinancialData)
      .subscribe(addFinancialData => {
        this.disabledOnclick = false;
        if (addFinancialData.status == 0) {
          this.alert.success(addFinancialData.message);
        }
        else {
          this.alert.error( JSON.stringify(addFinancialData.err_fields) + ' fields are required or invalid.'); 
          // this.alert.error(addFinancialData.message);
        }
      });
  }

  /**
   * function check validation on share capital tab
   */
  checkfinanceValidation() {

    var AuthorizedShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.authorizedEquityShareCapital.value);
    var IssuedEquityShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.issuedEquityShareCapital.value);
    var SubscribedShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.subscribedShareCapital.value);
    var PaidupEquityShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.paidupEquityShareCapital.value);
    var AuthorizedPreferenceShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.authorizedPreferenceShareCapital.value);
    var IssuedPreferenceShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.issuedPreferenceShareCapital.value);
    var SubscribedPreferenceShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.subscribedPreferenceShareCapital.value);
    var PaidupPreferenceShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.paidupPreferenceShareCapital.value);


    // check validation for AuthorizedShareCapital
    if (AuthorizedShareCapital != "" || AuthorizedShareCapital !== null) {
      if (parseFloat(AuthorizedShareCapital) < parseFloat(IssuedEquityShareCapital)) {
        this.checkValidationInput = true;
        this.IssuedEquityError = {
          isError: true, errorMessage: 'Should not be greater than Authorized Equity Share Capital.'
        };
        return false;
      }
      else if (parseFloat(AuthorizedShareCapital) < parseFloat(SubscribedShareCapital)) {
        this.checkValidationInput = true;
        this.SubscribedShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Equity Share Capital.'
        };
        return false;
      }
      else if (parseFloat(AuthorizedShareCapital) < parseFloat(PaidupEquityShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupEquityShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Equity Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.IssuedEquityError = {
          isError: false
        };
        this.SubscribedShareCapital = {
          isError: false
        };
        this.PaidupEquityShareCapital = {
          isError: false
        };

      }
    }

    // check validation for IssuedEquityShareCapital
    if (IssuedEquityShareCapital != "" || IssuedEquityShareCapital !== null) {
      if (parseFloat(IssuedEquityShareCapital) < parseFloat(SubscribedShareCapital)) {
        this.checkValidationInput = true;
        this.SubscribedShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Issued Equity Share Capital.'
        };
        return false;
      }
      else if (parseFloat(IssuedEquityShareCapital) < parseFloat(PaidupEquityShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupEquityShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Issued Equity Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.SubscribedShareCapital = {
          isError: false
        };
        this.PaidupEquityShareCapital = {
          isError: false
        };
      }
    }

    // check validation for SubscribedShareCapital
    if (SubscribedShareCapital != "" || SubscribedShareCapital !== null) {
      if (parseFloat(SubscribedShareCapital) < parseFloat(PaidupEquityShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupEquityShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Subscribed Equity Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.PaidupEquityShareCapital = {
          isError: false
        };

      }
    }

    // check validation for AuthorizedPreferenceShareCapital
    if (AuthorizedPreferenceShareCapital != "" || AuthorizedPreferenceShareCapital !== null) {
      if ((parseFloat(AuthorizedPreferenceShareCapital)) < parseFloat(IssuedPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.IssuedPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Preference Share Capital.'
        };
        return false;
      } else if ((parseFloat(AuthorizedPreferenceShareCapital)) < parseFloat(SubscribedPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.SubscribedPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Preference Share Capital.'
        };
        return false;
      } else if ((parseFloat(AuthorizedPreferenceShareCapital)) < parseFloat(PaidupPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Preference Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.IssuedPreferenceShareCapital = {
          isError: false
        };
        this.SubscribedPreferenceShareCapital = {
          isError: false
        };
        this.PaidupPreferenceShareCapital = {
          isError: false
        };
      }
    }

    // check validation for IssuedPreferenceShareCapital
    if (IssuedPreferenceShareCapital != "" || IssuedPreferenceShareCapital !== null) {
      if (parseFloat(IssuedPreferenceShareCapital) < parseFloat(SubscribedPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.SubscribedPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Issued Preference Share Capital.'
        };
        return false;
      } else if (parseFloat(IssuedPreferenceShareCapital) < parseFloat(PaidupPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Issued Preference Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.SubscribedPreferenceShareCapital = {
          isError: false
        };
        this.PaidupPreferenceShareCapital = {
          isError: false
        };
      }
    }

    // check validation for IssuedPreferenceShareCapital
    if (SubscribedPreferenceShareCapital != "" || IssuedPreferenceShareCapital !== null) {
      if (parseFloat(SubscribedPreferenceShareCapital) < parseFloat(PaidupPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Subscribed Preference Share Capital'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.PaidupPreferenceShareCapital = {
          isError: false
        };

      }
    }
    else
      this.error = { isError: false, errorMessage: '' }

    return true;
  }

  compareTwoDates() {

    if (this.financialYearToModel == null && this.financialYearFromModel == null) {
      this.error = { isError: false, errorMessage: '' }
      return true;
    }

    if (this.financialYearToModel == null || this.financialYearFromModel == null) {
      this.error = {
        isError: true, errorMessage: 'Both date is required.'
      };
      return false;
    }

    if (new Date(this.setDate(this.financialYearToModel)) < new Date(this.setDate(this.financialYearFromModel))) {
      this.error = {
        isError: true, errorMessage: 'Financial year To date cannot be set before Financial year From date.'
      };
      return false;
    }
    else
      this.error = { isError: false, errorMessage: '' }

    return true;
  }

  onlyTwoDecimal(ev) {
    $('.dacimalFix').on('input', function () {
      this.value = this.value.replace(/(\.[\d]{2})./g, '$1'); // not more than 2 digits after decimal
    });
  }


  //--DELETE selected category for assessment
  deleteConfirmation(companyId) {
    this.companyId = companyId
    $('#confirmation').modal('toggle');
  }

  deleteCompany() {

    this.companyMasterService.deleteCompany(this.companyId).subscribe((data:any) => {
      if (data.status == 0) {
        $('#confirmation').modal('toggle');
        $('#alertTitle').text("Success!");
        $('#alertTitle').css("color", "black");
        $('#alertMessage').text("Company deleted successfully.");
        $('#alertMessage').css("color", "black");
        $('#messagePopUp').modal('toggle');
        this.messagePopUpTimeoutToogle();

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
        // this.getCompaniesList();
      }
      else {
        $('#confirmation').modal('toggle');
        $('#alertTitle').text("Failure!");
        $('#alertTitle').css('color', '#f00');
        $('#alertMessage').text(data.message);
        $('#alertMessage').css('color', '#f00');
        $('#messagePopUp').modal('toggle');
        this.messagePopUpTimeoutToogle();
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      }
    });
  }


  validatepaidUp() {
    return false;
  }

  setCompnayDetails() {
    var loginUsers = JSON.parse(localStorage.getItem('companyDetails'));

    this.companyID = loginUsers.companyID;
    this.companyName = loginUsers.companyName;
  }


  //Loans And INvestments
  loansGivenModel: any = 0;
  Guarantee: any = 0;
  Acquisition: any = 0;
  Others: any = 0;
  TotalLoansInvestment: any = 0;

  getTotalLoansAndInvestment() {

    if (this.loansGivenModel == undefined) { this.loansGivenModel == 0 }
    if (this.Guarantee == undefined) { this.Guarantee == 0 }
    if (this.Acquisition == undefined) { this.Acquisition == 0 }
    if (this.Others == undefined) { this.Others == 0 }
    if (this.TotalLoansInvestment == undefined) { this.TotalLoansInvestment == 0 }

    this.TotalLoansInvestment = parseFloat(this.loansGivenModel) + parseFloat(this.Guarantee) + parseFloat(this.Acquisition) + parseFloat(this.Others)
  }


  //Borrowng Tab Calculations
  getBorrowning() {
    this.TotalBorrowingAggregate = parseFloat(this.LoansfromBank) + parseFloat(this.DeferredPayment) + parseFloat(this.Depositsaccepted) + parseFloat(this.LoansandAdvances) + parseFloat(this.LongTermMaturities) + parseFloat(this.BondsDebentures)
  }
  commaSeperatedToNumberOnly(value) {
    if (value == "" || value == null || value == undefined) {
      return "";
    }
    else {
      value = value.toString();
      return value.replace(new RegExp(",".replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), "");
    }
  }

 
  

}
